import React from 'react';

const Spinner = () => (
    <div className="spinner-wrap">
        <div className="spinner" />
    </div>
);

export default Spinner;
